import { IonSkeletonText } from "@ionic/react";
import React from "react";
import MaxWidthContainer from "../MaxWidthContainer/MaxWidthContainer";

const CategorySkeleton = () => {
  return (
    <MaxWidthContainer>
      <div className="sticky top-1 left-0 w-full h-60 -z-10">
        <IonSkeletonText animated className="h-full w-full rounded-t-3xl" />
      </div>
      <div className="relative rounded-t-3xl min-h-screen bg-white">
        <div className="flex flex-col gap-[1.875rem] p-5 pb-0">
          <div className="flex flex-col gap-2.5 rounded-3xl">
            <IonSkeletonText animated className="h-7 w-3/4" />
          </div>

          <div className="flex flex-col gap-5">
            {/* Category Filters Skeleton */}
            <div className="flex gap-2 overflow-x-auto">
              {[1, 2, 3, 4].map((i) => (
                <IonSkeletonText key={i} animated className="h-8 w-28 rounded-full" />
              ))}
            </div>

            {/* Products List Skeleton */}
            <div className="flex flex-col gap-2">
              <IonSkeletonText animated className="h-6 w-32" />
              <div className="grid grid-cols-2 justify-center gap-y-2.5 gap-x-2.5">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="flex flex-col border rounded-lg p-2 gap-2">
                    <IonSkeletonText animated className="h-28 w-full rounded-lg" />
                    <IonSkeletonText animated className="h-4 w-3/4" />
                    <IonSkeletonText animated className="h-4 w-1/2" />
                    <div className="flex justify-between items-center">
                      <IonSkeletonText animated className="h-5 w-16" />
                      <IonSkeletonText animated className="h-8 w-8 rounded-full" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MaxWidthContainer>
  );
};

export default CategorySkeleton;
